import React, { useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Box, Button, Theme, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import DbScene from './DbScene';
import GradientButton from './GradientButton';

var skeleton = require('../assets/hacker_ske.json');
var texJson = require('../assets/hacker_tex.json');
var texPng = require('../assets/hacker_tex.png');

const useStyles = makeStyles((theme: Theme) => ({
  outlineButton: {
    borderColor: '#FFF',
    borderRadius: 16,
    color: '#FFF',
    padding: '8px 32px',
  },
  pixiCanvas: {
    height: 250,
    marginLeft: 32,
    width: 500,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
}));

interface IProps {
  loggedIn: boolean;
}

const Jumbotron: React.FC<IProps> = ({ loggedIn }) => {
  const history = useHistory();
  const { outlineButton, pixiCanvas } = useStyles();
  const divRef = useRef(null);

  useEffect(() => {
    new DbScene(divRef.current, skeleton, texJson, texPng, 'boy', 'idle');
  }, []);

  return (
    <Box display='flex'>
      <div>
        <Typography variant='h3'>Cyber Security คืออะไร ?</Typography>
        <Box height={8} />
        <Typography variant='h4'>
          เพิ่มความตระหนักในการใช้อินเทอร์เน็ต
        </Typography>
        <Box height={8} />
        <Typography variant='body1'>
          โดยหลีกเลี่ยงการเข้าเว็บไซต์ที่ไม่เหมาะสมหรือเว็บไซต์ผิดกฎหมายและไม่คลิกไฟล์แนบจากแหล่งที่ไม่น่าเชื่อถือหรือ
          ไม่รู้จักมาก่อนนอกจากนี้ ยังต้อง ระมัดระวังการเปิดไฟล์ผ่านช่องทาง
          Social Media เพื่อหลีกเลี่ยง
          การติดมัลแวร์ยิ่งแพร่ระบาดผ่านช่องทางนี้มากขึ้นทุกวัน
        </Typography>
        <Box height={16} />
        <Box display='flex'>
          <GradientButton
            color1='#7D1AFF'
            color2='#30CEFF'
            text='เข้าสู่เกม'
            onClick={() => history.push('/game')}
          />
          <Box width={16} />
          {!loggedIn && (
            <Button
              className={outlineButton}
              variant='outlined'
              onClick={() => history.push('/register')}
            >
              สร้างบัญชีผู้ใช้
            </Button>
          )}
        </Box>
      </div>
      <div className={pixiCanvas} ref={divRef} />
    </Box>
  );
};

export default Jumbotron;
